import React from 'react';
import { Box, Container, Grid, Skeleton } from '@mui/material';
import StyledBox from 'views/rebranded-module/information-module/AboutUsViewV2/components/LeadershipSection/LeadershipSection.styles';

const LeadershipSectionSkeleton: React.FC = () => {
  return (
    <StyledBox>
      <Container maxWidth="xl" className="LSContainer">
        <Grid container spacing={10}>
          {/* Left Column - Image */}
          <Grid item xl={6} lg={6} md={12} sm={12} className="LSImageColumn">
            <Skeleton variant="rectangular" width="100%" height={424} />
          </Grid>

          {/* Right Column - Text Content */}
          <Grid item xl={6} lg={6} md={12} sm={12} xs={12} className="LSTextColumn">
            {/* Heading */}
            <Box className="LSHeadingContainer">
              <Skeleton variant="text" width="90%" height={40} sx={{ mb: 5 }} />
            </Box>

            {/* First Paragraph */}
            <Box sx={{ mb: 3 }}>
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="98%" height={24} />
              <Skeleton variant="text" width="95%" height={24} />
              <Skeleton variant="text" width="92%" height={24} />
            </Box>

            {/* Quote */}
            <Box sx={{ mb: 2 }}>
              <Skeleton variant="text" width="100%" height={24} />
              <Skeleton variant="text" width="98%" height={24} />
              <Skeleton variant="text" width="95%" height={24} />
              <Skeleton variant="text" width="90%" height={24} />
              <Skeleton variant="text" width="85%" height={24} />
            </Box>

            {/* Signature */}
            <Skeleton variant="text" width="40%" height={32} sx={{ ml: 'auto' }} />
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { LeadershipSectionSkeleton };
